var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "layout",
    {
      scopedSlots: _vm._u([
        {
          key: "aside-control",
          fn: function () {
            return [
              _c("tool-layers", {
                attrs: {
                  moduleCode: _vm.moduleCode,
                  showButtonOnActionMap: false,
                },
              }),
              _vm._v(" "),
              _c("tool-printvisible", {
                attrs: {
                  moduleCode: _vm.moduleCode,
                  showButtonOnActionMap: false,
                },
              }),
              _vm._v(" "),
              _c("tool-regulations", {
                attrs: {
                  moduleCode: _vm.moduleCode,
                  showButtonOnActionMap: false,
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("map-component", {
        ref: "MapComponent",
        attrs: {
          id: _vm.mapId,
          url: _vm.url,
          acl: _vm.acl,
          mapTools: _vm.mapTools,
          moduleCode: _vm.moduleCode,
          showLoadingSpin: false,
          activeExpandCollapse: _vm.activeExpandCollapse,
          initialCollapsedExpandCollapse: _vm.initialCollapsedExpandCollapse,
          enableLayerSwitcher: _vm.enableLayerSwitcher,
          enableStreetView: _vm.enableStreetView,
          enableBackoffice: _vm.enableBackoffice,
          enableIdentify: _vm.enableIdentify,
          enableScaleLine: _vm.enableScaleLine,
          enableScaleBox: _vm.enableScaleBox,
          enableMousePosition: _vm.enableMousePosition,
          enableMeasure: _vm.enableMeasure,
          enableCatalog: _vm.enableCatalog,
          enableAnnotations: _vm.enableAnnotations,
          enableAttribution: _vm.enableAttribution,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }